import { keyBy } from "lodash";
import LogIn from "../pages/auth/login";
import Dashboard from "../pages/dashboard";
import ForgotPassword from "../pages/auth/forgot-password";
import SignUp from "../pages/auth/sign-up";
import Company from "../pages/user/company";
import Profile from "../pages/user/profile";
import UserList from "../pages/user/lists";
import addApp from "../pages/add-app";
import Campaign from "../pages/campaign/create-campign";
import SignUpAcknowledgement from "../pages/auth/sign-up/acknowledgement";
import Report from "../pages/report";

interface IRoute {
  path: string;
  component: React.ComponentType;
  isPublic?: boolean;
  label: string;
}

export const routes: Array<IRoute> = [
  { path: "/dashboard", component: Dashboard, label: "Dashboard" },
  { path: "/user/company", component: Company, label: "Add Compnay" },
  { path: "/user/profile", component: Profile, label: "Edit Profile" },
  { path: "/business-users", component: UserList, label: "Users" },
  { path: "/add-app", component: addApp, label: "Add App" },
  { path: "/create-campaign", component: Campaign, label: "Campaign" },
  {
    path: "/campaign/:campaign/:step",
    component: Campaign,
    label: "Edit Campaign",
  },
  {
    path: "/login",
    component: LogIn,
    isPublic: true,
    label: "Login",
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    isPublic: true,
    label: "Forgot Password",
  },
  {
    path: "/forgot-password/:token",
    component: ForgotPassword,
    isPublic: true,
    label: "Forgot Password",
  },
  {
    path: "/sign-up",
    component: SignUp,
    isPublic: true,
    label: "Sign Up",
  },
  {
    path: "/sign-up/acknowledgement",
    component: SignUpAcknowledgement,
    isPublic: true,
    label: "Sign Up - Acknowledgement",
  },
  {
    path: "/reporting",
    component: Report,
    label: "Report",
  },
];

export const routeMapping = keyBy(routes, "label");
